"use client"

import { Card, CardContent } from "@/components/ui/card"
import { CheckCircle } from "lucide-react"
import { useTranslations } from "next-intl"

export default function About() {
  const t = useTranslations("about")

  return (
    <section id="about" className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-high-contrast mb-6">
            {t("title")} <span className="gradient-text">{t("titleHighlight")}</span>
          </h2>
          <p className="text-xl text-low-contrast max-w-3xl mx-auto">{t("description")}</p>
        </div>
      </div>
    </section>
  )
}
